import { post } from '../../../../infra/rest';

export const logout = async () => {
  return await post(`/v1/organization/logout`, undefined, true);
};
